module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HWK86Q.6ef11e9e.jpg";